import { render, staticRenderFns } from "./Pipe.global.vue?vue&type=template&id=1c1153b4&scoped=true&lang=pug&"
import script from "./Pipe.global.vue?vue&type=script&lang=ts&"
export * from "./Pipe.global.vue?vue&type=script&lang=ts&"
import style0 from "./Pipe.global.vue?vue&type=style&index=0&id=1c1153b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1153b4",
  null
  
)

export default component.exports